export enum GRADE_LEVEL_LABEL {
  KINDERGARTEN = 'Kindergarten',
  KINDER = 'Kinder',
  KIN = 'Kin',
  K = 'K',
}
